<div class="modal right" id="invoiceDetail" tabindex="-1" role="dialog" aria-labelledby="invoiceDetailLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
                    <h4 id="invoiceDetailLabel">Invoice Detail</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-6 mt-2">
									<div class="print-modal-customer">
										<div class="panel mb-10">
											<p>
												<strong>Invoice ID </strong>
												<span>
													{{ invoice.unique_id }}
												</span>
											</p>
											<p>
												<strong>Date</strong>
												<span>
													{{ invoice.date }}
												</span>
											</p>
											<p>
												<strong>Partner </strong>
												<span>
													{{ invoice.customer ? invoice.customer.customer_name : '-' }} 
												</span>
											</p>
											<p>
												<strong>Description </strong>
												<span>
													{{ invoice.description }}
												</span>
											</p>
											<p>
												<strong>Status </strong>
												<span>
													<span ng-if="!invoice.status">Open</span>
                            						<span ng-if="invoice.status" style="color: rgb(43, 191, 201);">Paid</span>
												</span>
											</p>
										</div>
										
									</div>
								</div>
								<div class="col-md-6 mt-2">
									<div class="print-modal-customer">
										<div class="panel mb-10">
											<p>
												<strong>QTY </strong>
												<span>
													{{ invoice.qty }}
												</span>
											</p>
											<p>
												<strong>Total</strong>
												<span>
													${{ invoice.total | number:2 }}
												</span>
											</p>
											<p>
												<strong>Paid</strong>
												<span>
													${{ invoice.paid | number:2 }}
												</span>
											</p>
											<p>
												<strong>Balance Due </strong>
												<span>
													${{ invoice.balance_due | number:2 }}
												</span>
											</p>
											<p>
												<strong>Tax </strong>
												<span>
													${{ invoice.tax }}
												</span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="row" ng-repeat="item in invoice.invoices">
								<div class="col-md-6 mt-2">
									<div class="print-modal-customer">
										<div class="panel mb-10">
											<p>
												<strong>Invoice ID </strong>
												<span>
													{{ item.unique_id }}
												</span>
											</p>
											<p>
												<strong>Date</strong>
												<span>
													{{ item.date }}
												</span>
											</p>
											<p>
												<strong>Partner </strong>
												<span>
													{{ item.customer ? item.customer.customer_name : '-' }} 
												</span>
											</p>
											<p>
												<strong>Description </strong>
												<span>
													{{ item.description }}
												</span>
											</p>
											<p>
												<strong>Status </strong>
												<span>
													<span ng-if="!item.status">Open</span>
                            						<span ng-if="item.status" style="color: rgb(43, 191, 201);">Paid</span>
												</span>
											</p>
										</div>
										
									</div>
								</div>
								<div class="col-md-6 mt-2">
									<div class="print-modal-customer">
										<div class="panel mb-10">
											<p>
												<strong>QTY </strong>
												<span>
													{{ item.qty }}
												</span>
											</p>
											<p>
												<strong>Total</strong>
												<span>
													${{ item.total | number:2 }}
												</span>
											</p>
											<p>
												<strong>Paid</strong>
												<span>
													${{ item.paid | number:2 }}
												</span>
											</p>
											<p>
												<strong>Balance Due </strong>
												<span>
													${{ item.balance_due | number:2 }}
												</span>
											</p>
											<p>
												<strong>Tax </strong>
												<span>
													${{ item.tax }}
												</span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<a href="#" 
										class="hod-button blue ml10" 
										ng-click="editInvoice()">
										Edit Invoice
									</a>
									<a href="#" 
										class="hod-button blue ml10" 
										ng-click="newPayment()">
										Add Payment
									</a>
									<a href="#" 
										class="hod-button blue ml10"
										ng-if="!invoice.status" 
										ng-click="changeStatus(1)">
										Change status to Paid
									</a>
									<a href="#" 
										class="hod-button blue ml10"
										ng-if="invoice.status" 
										ng-click="changeStatus(0)">
										Change status to Open
									</a>
								</div>
							</div>
							<div class="row mt-4">
								<div class="col-md-12">
									<div class="panel-heading">
										<span class="panel-title"> Payments</span>
										<hr>
									</div>
									<div class="table-responsive" ng-if="invoice.payments.length > 0">
										<table class="table table-hover tc-checkbox-1 fs13">
											<thead class="p20">
												<tr class="bg-light">
													<th></th>
													<th>Rate</th>
													<th>Qty</th>
													<th>Price</th>
													<th>Type</th>
													<th>Description</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr class="text-left" ng-repeat="item in invoice.payments | orderBy:sortType:sortReverse ">
													<td class="clickable-row">{{ item.id }}</td>
													<td class="clickable-row">{{ item.rate}}</td>
													<td class="clickable-row">{{ item.qty}}</td>
													<td class="clickable-row">{{ item.price}}</td>
													<td class="clickable-row">{{ item.type == 0 ? 'Debt' : 'Credit' }}</td>
													<td class="clickable-row">{{ item.description}}</td>
													<td class="clickable-row" >
														<a href="#" class="btn btn-primary" ng-click="openPayment(item)">
															Edit
														</a>
														<a href="#" class="btn btn-danger" ng-click="deletePayment(item)">
															Delete
														</a>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="text-center mt50" ng-if="invoice.payments.length == 0">
										<h3 style="font-size: 48px;font-weight: 800;">Payment not found</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
